import React, { useEffect, useRef, useState } from "react";
import { MapPin } from "lucide-react";

const GEO = "https://data.geopf.fr/geocodage/search";
export const EMPTY_ADDR = { street: "", postcode: "", city: "", country: "France" };
export const addrToText = (a) => (a?.street ? `${a.street.trim()}, ${a.postcode.trim()} ${a.city.trim()}${a.country && a.country !== "France" ? `, ${a.country.trim()}` : ""}`.trim() : "");
export const addrValid = (a) => !!(a?.street?.trim() && a?.postcode?.trim() && a?.city?.trim() && a?.country?.trim());

export function AddressFields({ label, value, onChange, testid }) {
  const [hits, setHits] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef(null);
  const inputRef = useRef(null);
  const set = (k, v) => onChange({ ...value, [k]: v });
  useEffect(() => () => clearTimeout(timer.current), []);
  const search = (q) => {
    set("street", q);
    clearTimeout(timer.current);
    if ((value.country || "France") !== "France" || q.trim().length < 3) { setHits([]); return; }
    timer.current = setTimeout(async () => {
      try {
        const r = await fetch(`${GEO}?q=${encodeURIComponent(q)}&limit=6&autocomplete=1&index=address`);
        const j = await r.json();
        setHits((j.features || []).map((f) => f.properties)); setOpen(document.activeElement === inputRef.current);
      } catch { setHits([]); }
    }, 250);
  };
  const pick = (p) => { onChange({ ...value, street: p.name, postcode: p.postcode || "", city: p.city || "", country: "France" }); setOpen(false); setHits([]); };
  return (
    <div className="space-y-2" data-testid={testid}>
      <span className="text-[10px] uppercase tracking-[0.2em] text-white/55">{label}</span>
      <div className="relative">
        <div className="flex items-stretch border border-white/15 bg-black/60 min-h-[48px]">
          <span className="flex items-center justify-center w-11 shrink-0 border-r border-white/10"><MapPin size={16} className="text-[#DCB457]" /></span>
          <input ref={inputRef} value={value.street} onChange={(e) => search(e.target.value)} onFocus={() => hits.length && setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 180)}
            placeholder="N° et rue (ex. 12 rue de la Gare)" autoComplete="off" className="flex-1 min-w-0 bg-transparent px-3 text-white outline-none placeholder:text-white/40" data-testid={`${testid}-street`} />
        </div>
        {open && hits.length > 0 && (
          <div className="absolute z-30 left-0 right-0 mt-1 bg-[#0b0b0b] border border-[#DCB457]/35 max-h-64 overflow-y-auto" data-testid={`${testid}-suggestions`}>
            {hits.map((p, i) => <button type="button" key={p.id || i} onMouseDown={(e) => e.preventDefault()} onClick={() => pick(p)} className="w-full text-left px-3 py-2.5 text-sm hover:bg-[#DCB457]/10" data-testid={`${testid}-suggestion-${i}`}>{p.label}</button>)}
          </div>
        )}
      </div>
      <div className="grid grid-cols-12 gap-2">
        <input value={value.postcode} onChange={(e) => set("postcode", e.target.value)} placeholder="Code postal" inputMode="numeric" className="input-luxe col-span-5 md:col-span-3" data-testid={`${testid}-postcode`} />
        <input value={value.city} onChange={(e) => set("city", e.target.value)} placeholder="Ville" className="input-luxe col-span-7 md:col-span-6" data-testid={`${testid}-city`} />
        <input value={value.country} onChange={(e) => set("country", e.target.value)} placeholder="Pays" className="input-luxe col-span-12 md:col-span-3" data-testid={`${testid}-country`} />
      </div>
    </div>
  );
}
